module.exports = __webpack_public_path__ + "static/media/white_preloader_s.437593ca.gif";